import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

function QuickBooksLogo() {
  return (
    <div className="w-10 h-10 rounded-lg bg-[#2CA01C] flex items-center justify-center text-white font-bold text-sm shadow-sm">
      qb
    </div>
  );
}

export default function IntegrationCard({
  title,
  description,
  connected,
  connecting,
  disconnecting,
  onConnect,
  onDisconnect,
}) {
  return (
    <Card className="border-gray-200 shadow-sm">
      <CardHeader>
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <QuickBooksLogo />
            <div>
              <CardTitle className="text-lg text-gray-900">{title}</CardTitle>
              <CardDescription className="mt-1">{description}</CardDescription>
            </div>
          </div>
          <span
            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
              connected ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
            }`}
          >
            {connected ? '● Connected' : '○ Disconnected'}
          </span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            {connected
              ? 'QuickBooks is connected and ready to sync customers and invoices.'
              : 'Connect your QuickBooks account to enable customer and invoice sync.'}
          </p>

          {connected ? (
            <Button
              type="button"
              variant="outline"
              onClick={onDisconnect}
              disabled={disconnecting}
              className="border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800 min-w-[120px]"
            >
              {disconnecting ? 'Disconnecting...' : 'Disconnect'}
            </Button>
          ) : (
            <Button
              type="button"
              onClick={onConnect}
              disabled={connecting}
              className="bg-green-600 hover:bg-green-700 text-white min-w-[120px]"
            >
              {connecting ? 'Connecting...' : 'Connect'}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
